<div *ngIf="loaded===1">

    <!------------------------------------------------------------------------- BANNER VERSION ESCRITORIO -->

    <section class="backDark banner pdt70 pdb30" fxShow="true" fxShow.lt-md="false">
        <div class="cw" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="300px" fxLayoutGap.lt-md="1rem">
            <img [src]=instructor.foto class="imgInstructor">
            <div></div>
            <div fxLayout="column" fxLayoutAlign="end " class="zIndex1">
                <a (click)=regresarInstructores() class="gray-3 cursorPointer" >Instructores <span class="ft10 gray-3">></span> </a>
                <div fxLayout="row" fxLayoutAlign=" center">
                    <h5 class="gray-1a mgb0 mgr10"> {{instructor.nombre}} </h5>
                    <a href="{{instructor.enlaceLinkedin}}" target="_blank" class="pdt05">
                        <i class="fab fa-linkedin blueLink linkIcon ft20"></i>
                    </a>

                </div>
                <h6 class="light-link-color ft300 ft16">{{instructor.resumen}}</h6>

                <div *ngIf="instructor.empresaNombre" fxLayout="row">
                    <a routerLink="/empresa/{{instructor.empresaId}}">
                        <span class="mgt10 mgb10 chip gray-7 cursorPointer">{{instructor.empresaNombre}}</span>
                    </a>
                </div>

            </div>
        </div>
    </section>

    <!------------------------------------------------------------------------- BANNER VERSION MOBILE -->

    <section class="backDark banner pdt30 pdb30" fxShow="false" fxShow.lt-md="true">

        <div class="cw" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="300px" fxLayoutGap.lt-md="1rem">
            <div fxLayoutAlign="center" fxFlex="100%">
                <img [src]=instructor.foto class="avatarSquare10 radius10 shadow10 mgb10">
            </div>

            <div fxLayout="column" fxLayoutAlign="center center" class="zIndex1">
                <div fxLayout="row" fxLayoutAlign=" center">
                    <h5 class="gray-1a mgb0 mgr10"> {{instructor.nombre}} </h5>
                    <a href="{{instructor.enlaceLinkedin}}" target="_blank" class="pdt05" fxShow="true"
                        fxShow.lt-md="false">
                        <i class="fab fa-linkedin blueLink linkIcon ft20"></i>
                    </a>
                </div>
                <h6 class="light-link-color ft300 ft16">{{instructor.resumen}}</h6>

                <div *ngIf="instructor.empresaNombre" fxLayout="row">
                    <a routerLink="/empresa/{{instructor.empresaId}}">
                        <span class="mgt10 mgb10 chip gray-7 cursorPointer">{{instructor.empresaNombre}}</span>
                    </a>
                </div>
                <a href="{{instructor.enlaceLinkedin}}" target="_blank" class="pdt05 mgt20" fxShow="false"
                    fxShow.lt-md="true">
                    <i class="fab fa-linkedin blueLink linkIcon ftxxl"></i>
                </a>

            </div>
        </div>
    </section>

    <!------------------------------------------------------------------------- INFORMACION GENERAL  -->

    <section ngClass.gt-sm="pdt40" ngClass.lt-md="pdt20">
        <div fxLayout="row" fxLayoutAlign="space-between" fxLayoutGap="4rem" fxLayoutGap.lt-md="1rem"
            fxLayout.lt-md="column" class="cw">

            <!------------------------------------------------------------------------- COLUMNA IZQUIERDA -->
            <div fxFlex="50%">
                <h6 class="h6Title">Resumen de instructor</h6>
                <p>{{instructor.descripcion}}</p>
            </div>

            <!------------------------------------------------------------------------- COLUMNADERECHA -->
            <div fxFlex="50%">
                <h6 class="h6Title">Cursos de {{instructor.nombre}}</h6>

                <!-- CURSO DE INSTRUCTOR -->
                <div *ngFor="let item of cursosInstructor;  let i=index">
                    <div routerLink="/curso/{{item.id}}" class="mgt20 cursorPointer" fxLayout="row" fxLayoutAlign="space-between" fxLayoutGap="2rem">
                        <div fxLayout="row" fxLayoutGap="1rem" fxFlex="90%" fxFlex.lt-md="100%">
                            <img [src]=item.foto ngClass.gt-sm="imgCurso" ngClass.lt-md="avatarSquare8 radius3">
                            <div>
                                <h6 class="ft13 ft500 mgt0 mgb05">
                                    {{item.titulo}}
                                </h6>
                                <p class="mgt0 mgb0 ft12">{{item.resumen}} </p>

                                <span class="ft500 gray-8" fxShow="false" fxShow.lt-md="true">
                                    $ {{item.precioFinal}}
                                </span>
                            </div>
                        </div>
                        <div fxFlex="10%" fxLayoutAlign="end" fxShow="true" fxShow.lt-md="false">
                            <span class="ft500 gray-8"> $ {{item.precioFinal}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>

<div *ngIf="loaded===0">
    <div *ssrExclude>
        <spinner></spinner>
    </div>
</div>